import { render, staticRenderFns } from "./VQLong.vue?vue&type=template&id=74df0418&scoped=true"
import script from "./VQLong.vue?vue&type=script&lang=js"
export * from "./VQLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df0418",
  null
  
)

export default component.exports